import { memo, useState, useEffect } from "react";
import "../css/navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const detectBackground = () => {
      const el = document.elementFromPoint(
        window.innerWidth / 2,
        80
      );

      if (!el) return;

      const bg = window.getComputedStyle(el).backgroundColor;

      // RGB extract
      const rgb = bg.match(/\d+/g);

      if (!rgb) return;

      const brightness =
        (rgb[0] * 299 +
          rgb[1] * 587 +
          rgb[2] * 114) /
        1000;

      setIsDark(brightness < 128);
    };

    detectBackground();

    window.addEventListener("scroll", detectBackground);

    return () =>
      window.removeEventListener(
        "scroll",
        detectBackground
      );
  }, []);
  useEffect(() => {
    // SPA navigation handler
    const handleClick = (e) => {
      const link = e.target.closest('a[data-spa]');
      if (!link) return;

      e.preventDefault();
      const href = link.getAttribute('href');

      // Push state without reload
      window.history.pushState({}, '', href);

      // Notify app (simple event)
      window.dispatchEvent(new PopStateEvent('popstate'));

      setIsMenuOpen(false);
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <div className="navbar-content">
      {/* Brand */}
      <div className="navbar-brand">
        <a href="/" className="logo-Name" data-spa style={{ color: "#000" }}>
          RESUME ERA
        </a><br style={{ marginTop: '-14px' }} />
        <p
          className="brand-subtitle"
          style={{
            fontSize: '15px',
            marginTop: '-1px',
            background: 'linear-gradient(90deg, #ff7e5f, #5fdb65)',
            WebkitBackgroundClip: 'text',    // text color: 'transparent',
            WebkitTextFillColor: 'transparent'
          }}
        >
          Free Resume builder
        </p>
      </div>

      {/* Hamburger */}
      <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
        <span className="hamburger-icon" title="Menu">&#9776;</span>
      </div>

      {/* Links */}
      <div className={`navbar-links ${isMenuOpen ? "open" : ""}`}>

        {/* INTERNAL SPA ROUTES */}
        <a className="navbar-link" href="/" data-spa>Home</a>
        <a className="navbar-link" href="/template" data-spa>Templates</a>
        {/* <a className="navbar-link" href="/myresume" data-spa>My Resume</a> */}
        {/* <a className="navbar-link" href="/cover_letter" data-spa>Cover Letter</a> */}

        {/* EXTERNAL / PHP APPS */}
        {/* <a
          className="navbar-link"
          href="https://resumeera.xyz/JobPost/jobs/"
        >
          All Jobs
        </a> */}


        {/* <a
          className="navbar-link"
          href="https://typingmaster.resumeera.xyz"
        >
          Typing App
        </a> */}
        <a
          className="navbar-link"
          href="https://resumeera.xyz/feature"
        >
          Free Resume Builder Feature
        </a>

      </div>
    </div>
  );
};

export default memo(Navbar);
